export const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  const firstChar = string.charAt(0);
  if (firstChar === firstChar.toUpperCase()) {
    return string;
  }
  return firstChar.toUpperCase() + string.slice(1);
};

export const capitalizeEachWord = (string) => {
  if (!string) return "";
  return string
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

